import * as z from "zod";
import {
  FlowContentNodeSchema,
  type FlowContentNode,
} from "./flow-content-node-schema";

/**
 * List item containing content.
 */
const ListItemNodeSchema_ = z.object({
  type: z.literal("listItem"),
  content: z.array(FlowContentNodeSchema),
});

/** Base type from schema inference (no index signature) */
type ListItemNodeBase = Omit<z.infer<typeof ListItemNodeSchema_>, "content"> & {
  content: FlowContentNode[];
};

/** Full type with index signature for FlowContentNode compatibility */
export type ListItemNode = ListItemNodeBase & { [key: string]: unknown };

export const ListItemNodeSchema: z.ZodType<ListItemNode> = ListItemNodeSchema_;

/**
 * Bullet (unordered) list node.
 */
const BulletListNodeSchema_ = z.object({
  type: z.literal("bulletList"),
  items: z.array(ListItemNodeSchema_),
});

/** Base type from schema inference (no index signature) */
type BulletListNodeBase = Omit<
  z.infer<typeof BulletListNodeSchema_>,
  "items"
> & { items: ListItemNode[] };

/** Full type with index signature for FlowContentNode compatibility */
export type BulletListNode = BulletListNodeBase & { [key: string]: unknown };

export const BulletListNodeSchema: z.ZodType<BulletListNode> =
  BulletListNodeSchema_;

/**
 * Ordered (numbered) list node.
 */
const OrderedListNodeSchema_ = z.object({
  type: z.literal("orderedList"),
  items: z.array(ListItemNodeSchema_),
});

/** Base type from schema inference (no index signature) */
type OrderedListNodeBase = Omit<
  z.infer<typeof OrderedListNodeSchema_>,
  "items"
> & { items: ListItemNode[] };

/** Full type with index signature for FlowContentNode compatibility */
export type OrderedListNode = OrderedListNodeBase & { [key: string]: unknown };

export const OrderedListNodeSchema: z.ZodType<OrderedListNode> =
  OrderedListNodeSchema_;
